import React from "react";
import { Route, Routes } from "react-router-dom";
import './App.css';
import DrawerAppBar from "./component/appbar/DrawerAppBar";
import About from "./pages/About";
import ContactUs from "./pages/ContactUs";
import Home from "./pages/Home";
import Pricing from "./pages/Pricing";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Support from "./pages/support";
import HelpDesk from "./pages/helpdesk";
import Career from "./pages/career";
import ParentUpgrade from "./pages/ParentUpgrade";
import ParentLogin from "./pages/ParentLogin";

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<DrawerAppBar />}>
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="contact" element={<ContactUs />} />
        <Route path="pricing" element={<Pricing />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="terms" element={<Terms />} />
        <Route path="support" element={<Support />} />
        <Route path="helpdesk" element={<HelpDesk />} />
        <Route path="career" element={<Career />} />
        <Route path="parentUpgrade" element={<ParentUpgrade />}/>
        <Route path="parentLogin" element={<ParentLogin />}/>
      </Route>
    </Routes>
  );
};

export default App;
